import { useSyncExternalStore } from 'react';

export type ThemePreference = 'system' | 'light' | 'dark';
const KEY = 'omnia.theme';
const listeners = new Set<() => void>();

function read(): ThemePreference {
  try {
    const value = localStorage.getItem(KEY);
    // Dark is the product's look; only an explicit choice in the View menu changes it.
    return value === 'light' || value === 'system' ? value : 'dark';
  } catch {
    // Storage can be unavailable (private mode, blocked site data); use the default look.
    return 'dark';
  }
}

let current = read();

export function applyTheme(preference: ThemePreference = current) {
  if (preference === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.dataset.theme = preference;
}

export function setTheme(preference: ThemePreference) {
  current = preference;
  try {
    localStorage.setItem(KEY, preference);
  } catch {
    // Not persisted this session; the choice still applies until reload.
  }
  applyTheme(preference);
  listeners.forEach((listener) => listener());
}

export function useTheme(): ThemePreference {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
  );
}
